// eslint-disable-next-line import/no-cycle
import http from './intercept';
import { getBaseURL, getEnvironmentHost } from '../env-config';

export const ApiService = {
  // Create a baseURL using the baseURL from envConfig.js
  baseURL: getBaseURL(),
  hostURL: getEnvironmentHost(),
  // Method to perform GET request
  Get: async (url, headers = {}) => {
    try {
      return http.get(`${url}`, { headers }); // Perform GET request with optional headers
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message); // Handle error response
    }
  },

  // Method to perform POST request
  Post: async (url, data, headers = {}) => {
    try {
      return http.post(`${url}`, data, { headers }); // Perform POST request with optional headers
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message); // Handle error response
    }
  },

  // Method to perform PUT request
  Put: async (url, data, headers = {}) => {
    try {
      return http.put(`${url}`, data, { headers }); // Perform PUT request with optional headers
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message); // Handle error response
    }
  },

  // Method to perform DELETE request
  Delete: async (url, headers = {}) => {
    try {
      return http.delete(`${url}`, { headers }); // Perform DELETE request with optional headers
    } catch (error) {
      throw new Error(error.response?.data?.error || error.message); // Handle error response
    }
  },
};

export default ApiService;
